import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const FeatureTogglesRoutes = defineRoute({
    index: {
        route: {
            path: "/feature/toggles",
            component: () => loadView(import("./FeatureToggles.vue")),
        },
    },
});
